import React from 'react';

import Tooltip from 'shared/components/atoms/Tooltip/NewTooltip';
import { Flex } from 'shared/components/display';

import fbUploadedIcon from 'shared/images/facebook/fb-uploaded-icon.svg';

import styles from './styles';

interface Props {
  showTooltip?: boolean;
  showHoverBox?: boolean;
}
const FacebookUploadedIcon: React.FC<Props> = ({ showTooltip = false }) => {
  return (
    <Tooltip content="Uploaded to the Meta Library" disabled={!showTooltip}>
      <Flex css={styles} className="fb-uploaded-icon">
        <img src={fbUploadedIcon} className="fb-uploaded-icon__icon" />
      </Flex>
    </Tooltip>
  );
};

export default FacebookUploadedIcon;
